import { create } from 'zustand'
import { createMyPromoterSlice } from './MyPromoter/index'
import { IMyPromoter } from './MyPromoter/interface'

export const useBoundPromoterStore = create<IMyPromoter>()(
  (...a) => ({
    ...createMyPromoterSlice(...a),
  }),
)
